module.exports = __webpack_public_path__ + "static/pilu-logo-1c01274d13c4d4fd9ebfa1b37d86f6f0.jpg";